import { useShipStore } from '@/state/useShipStore'
import { SHIP_TIERS } from '@/ships/shipTypes'
import './ShipHUD.css'

export function ShipHUD() {
  const aboard = useShipStore((s) => s.aboard)
  const activeShip = useShipStore((s) => s.getActiveShip())
  const portCooldown = useShipStore((s) => s.portCooldown)
  const starboardCooldown = useShipStore((s) => s.starboardCooldown)

  if (!aboard || !activeShip) return null

  const tierInfo = SHIP_TIERS[activeShip.tier]
  const healthPct = (activeShip.health / activeShip.maxHealth) * 100
  const portReady = portCooldown <= 0
  const starboardReady = starboardCooldown <= 0

  return (
    <div className="ship-hud">
      {/* Ship info */}
      <div className="ship-hud__info">
        <div className="ship-hud__name">{tierInfo.name}</div>
        <div className="ship-hud__health-bar">
          <div
            className="ship-hud__health-fill"
            style={{
              width: `${healthPct}%`,
              backgroundColor: healthPct > 60 ? '#4a8' : healthPct > 30 ? '#a84' : '#a44',
            }}
          />
        </div>
        <div className="ship-hud__health-text">
          {activeShip.health} / {activeShip.maxHealth}
        </div>
      </div>

      {/* Controls */}
      <div className="ship-hud__controls">
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">W</span>
          <span className="ship-hud__label">Sail Forward</span>
        </div>
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">S</span>
          <span className="ship-hud__label">Slow / Reverse</span>
        </div>
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">A / D</span>
          <span className="ship-hud__label">Rudder</span>
        </div>
        <div className="ship-hud__separator" />
        <div className="ship-hud__control-group">
          <span className={`ship-hud__key ${portReady ? 'ship-hud__key--ready' : 'ship-hud__key--cooldown'}`}>
            Q
          </span>
          <span className="ship-hud__label">
            Port Cannons {!portReady && `(${portCooldown.toFixed(1)}s)`}
          </span>
        </div>
        <div className="ship-hud__control-group">
          <span className={`ship-hud__key ${starboardReady ? 'ship-hud__key--ready' : 'ship-hud__key--cooldown'}`}>
            E
          </span>
          <span className="ship-hud__label">
            Starboard Cannons {!starboardReady && `(${starboardCooldown.toFixed(1)}s)`}
          </span>
        </div>
        <div className="ship-hud__separator" />
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">F</span>
          <span className="ship-hud__label">Disembark</span>
        </div>
      </div>
    </div>
  )
}
